<template>
	<div>
		<Card>
			<Form ref="formInline" :model="formInline" :rules="ruleInline" inline label-position="right">
				<FormItem label="设备编号" prop="EquipmentNo" :label-width="70">
					<Input style="width: 120px;" type="text" v-model="formInline.EquipmentNo" placeholder="设备编号">
					<!-- <span slot="prepend">设备编号</span> -->
					</Input>
				</FormItem>
				<FormItem label="充电站" prop="StationId" :label-width="70">
					<Select placeholder="站点列表" style="width:120px" v-model="formInline.StationId">
						<Option :value=0>全部</Option>
						<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">
							{{item.StationName}}
						</Option>
					</Select>
				</FormItem>
				<FormItem label="设备类型" prop="EquipmentType" :label-width="70">
					<Select placeholder="输入设备类型" style="width:120px" v-model="formInline.EquipmentType">
						<Option :value='1'>直流设备</Option>
						<Option :value='2'>交流设备</Option>
						<Option :value='3'>交直流一体设备</Option>
						<Option :value='4'>无线设备</Option>
						<Option :value='5'>其他</Option>
					</Select>
				</FormItem>
				<FormItem label="设备型号" prop="EquipmentModel" :label-width="70">
					<Input type="text" style="width:120px" v-model="formInline.EquipmentModel" placeholder="设备型号">
					<!-- <span slot="prepend">设备型号</span> -->
					</Input>
				</FormItem>
				<FormItem>
					<Button type="primary" @click="handleSubmit('formInline')">查询</Button>
				</FormItem>
			</Form>
		</Card>
		<Row :gutter="10" style="flex-wrap: nowrap;">
			<Col style="width: 400px;">
			<div style="margin: 0; padding: 0;">
				<Table ref="equipSelection" border :columns="equipColumns" :data="equipDatas" :height="tableHeight"
					@on-select="onEquipSelect">
					<template #result="{ row }">
						<Alert v-if="row.Result == 1" type="success">
							<Icon type="md-checkmark-circle" color="#19be6b" />成功
						</Alert>
						<Alert v-if="row.Result == 2" type="error">
							<Icon type="md-close-circle" color="#ed4014" />{{ row.ResultMsg }}
						</Alert>
					</template>
				</Table>
				<MyPage ref="equipPageList" :param="formInline" :url="getEquipmentInfoUrl" @listData='getDeviceList'></MyPage>
			</div>
			</Col>
			<Col style="width: calc(100% - 400px);">
			<div style="margin: 0; padding: 0;">
				<Table border :columns="dateItemColumns" :data="dateItemDatas" :height="tableHeight">
					<template #name="{ row }">
						<strong>{{ row.DataName }}</strong>
					</template>
					<template #readValue="{ row }">
						<div>{{ showReadValue(row) }}</div>
						<!-- 						<Input v-if="row.WidgetType == 1" v-model="row.ReadValue" placeholder="" disabled />
						<Select v-else-if="row.WidgetType == 2" v-model="row.ReadValue" >
							<Option v-for="item in row.WidgetOptionalDefine" :value="item.Value" :key="item.Value">{{ item.Text }}
							</Option>
						</Select>
						<i-switch v-else-if="row.WidgetType == 4" size="large" true-value="1" false-value="0"
							v-model="row.ReadValue" disabled>
							<span slot="open">启用</span>
							<span slot="close">不启用</span>
						</i-switch>
						<DatePicker v-else-if="row.WidgetType == 11" type="datetime" placeholder="选择日期和时间" v-model="row.ReadValue" disabled>
						</DatePicker>
						<TimePicker v-else-if="row.WidgetType == 12" format="HH:mm" placeholder="选择时分" v-model="row.ReadValue" disabled>
						</TimePicker> -->
					</template>
					<template #writeValue="{ row }">
						<Input v-if="row.WidgetType == 1" v-model="row.WriteValue" placeholder="" />
						<Select v-else-if="row.WidgetType == 2" v-model="row.WriteValue">
							<Option v-for="item in row.WidgetOptionalDefine" :value="item.Value" :key="item.Value">{{ item.Text }}
							</Option>
						</Select>
						<i-switch v-else-if="row.WidgetType == 4" size="large" true-value="1" false-value="0"
							v-model="row.WriteValue">
							<span slot="open">启用</span>
							<span slot="close">不启用</span>
						</i-switch>
						<DatePicker v-else-if="row.WidgetType == 11" format="yyyy-MM-dd HH:mm:ss" type="datetime"
							placeholder="选择日期和时间" v-model="row.WriteValue" on-change="onDateChange">
						</DatePicker>
						<TimePicker v-else-if="row.WidgetType == 12" format="HH:mm" placeholder="选择时分" v-model="row.WriteValue">
						</TimePicker>
					</template>
					<template #result="{ row }">
						<Alert v-if="row.Result == 1" type="success">
							<Icon type="md-checkmark-circle" color="#19be6b" />成功
						</Alert>
						<Alert v-if="row.Result == 2" type="error">
							<Icon type="md-close-circle" color="#ed4014" />{{ row.ResultMsg }}
						</Alert>
					</template>
					<template #action="{ row, index }">
						<Row :gutter="15" justify="center" align="middle" style="display: flex;">
							<Col :span="12"
								style="display: flex; flex-direction: column; justify-content: center; justify-items: center;">
							<Button v-if="row.ReadAble == 1" type="primary" @click="readParamValue(row)">读取</Button>
							<span v-else>&nbsp;</span>
							</Col>
							<Col :span="12"
								style="display: flex; flex-direction: column; justify-content: center; justify-items: center;">
							<Button v-if="row.WriteAble == 1" type="primary" @click="writeParamValue(row)">设置</Button>
							<span v-else>&nbsp;</span>
							</Col>
						</Row>
					</template>
				</Table>
			</div>
			</Col>
		</Row>
	</div>
</template>

<script>
	import {
		mapState,
	} from 'vuex';
	import webapi from '../../../webapi';
	import dateFormat from '../../../../public/js/comm.js';
	export default {
		data() {
			return {
				getEquipmentInfoUrl: webapi.base_api_url + '/System/GetEquipmentInfo',
				tableHeight: 0,
				formInline: {
					StationId: 0,
					EquipmentNo: '',
					EquipmentModel: '',
					EquipmentTypeDesc: '',
				},
				ruleInline: {

				},
				equipColumns: [{
						type: 'selection',
						width: 55
					},
					{
						title: '充电桩编码',
						key: 'EquipmentNo',
					},
					{
						title: '结果',
						slot: 'result',
						width: 120,
						align: 'center'
					}
				],
				equipDatas: [],
				dateItemColumns: [{
						title: '数据标识项名称',
						key: 'DataName',
						// tree: true
					},
					{
						title: '读取值',
						slot: 'readValue',
						// key: 'ReadValue'
					},
					{
						title: '设置值',
						// slot: 'writeValue',
						key: 'WriteValue',
						render: (h, params) => {
							// if (params.row.$isEdit) {
							if (params.row.WidgetType == 1) {
								return h("Input", {
									props: {
										type: 'text',
										value: '',
									},
									on: {
										'on-blur': event => {
											params.row.WriteValue = event.target.value;
											this.$set(params.row, '$isEdit', false);
										}
									}
								})
							} else if (params.row.WidgetType == 2) {
								return h('Select', {
										props: {

										},
										on: {
											'on-select': item => params.row.WriteValue = item.value,
										}
									},
									params.row.WidgetOptionalDefine.map(obj => {
										return h('Option', {
											props: {
												value: obj.Value,
												label: obj.Text
											}
										})
									})
								);
							} else if (params.row.WidgetType == 4) {
								return h('i-switch', {
										props: {
											size: 'large',
											trueValue: 1,
											falseValue: 0,
											value: params.row.WriteValue == 1 ? 1 : 0,
										},
										on: {
											'on-change': v => params.row.WriteValue = v ? 1 : 0,
										}
									},
									[h('span', {
										slot: 'open'
									}, '启用'), h('span', {
										slot: 'close'
									}, '禁用')])
							} else if (params.row.WidgetType == 11) {
								return h('DatePicker', {
									props: {
										type: 'datetime',
										format: 'yyyy-MM-dd HH:mm:ss',
									},
									on: {
										'on-change': (v, t) => params.row.WriteValue = v,
									}
								})
							} else if (params.row.WidgetType == 12) {
								return h('TimePicker', {
									props: {
										format: 'HH:mm',
									},
									on: {
										'on-change': (v, t) => params.row.WriteValue = v,
									}
								})
							}
							//	<Input v-if="row.WidgetType == 1" v-model="row.WriteValue" placeholder="" />
							//	<Select v-else-if="row.WidgetType == 2" v-model="row.WriteValue">
							//		<Option v-for="item in row.WidgetOptionalDefine" :value="item.Value" :key="item.Value">{{ item.Text }}
							//		</Option>
							//	</Select>
							//	<i-switch v-else-if="row.WidgetType == 4" size="large" true-value="1" false-value="0"
							//		v-model="row.WriteValue">
							//		<span slot="open">启用</span>
							//		<span slot="close">不启用</span>
							//	</i-switch>
							//	<DatePicker v-else-if="row.WidgetType == 11" format="" type="" placeholder="选择日期和时间" v-model="row.WriteValue" on-change="onDateChange">
							//	</DatePicker>
							//	<TimePicker v-else-if="row.WidgetType == 12" format="HH:mm" placeholder="选择时分" v-model="row.WriteValue">
							//	</TimePicker>

							// } else {
							// 	return h('div', {
							// 		class: 'cell-div',
							// 		style: 'height: 100%; width: 100%;',
							// 		on: {
							// 			click: () => { this.$set(params.row, '$isEdit', true); }
							// 		}
							// 	}, 'params.row.WriteValue' || ' ');
							// }
						}
					},
					{
						title: '单位',
						key: 'DataUnit',
						width: 70,
						align: 'center'
					},
					{
						title: '结果',
						slot: 'result',
						width: 120,
						align: 'center'
					},
					{
						title: '操作',
						slot: 'action',
						align: 'center',
						width: 200
					}
				],
				dateItemDatas: []
			}
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 220;
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			const _this = this;
			this.getParametersItemList();
			_this.handleSubmit();
		},
		computed: {
			...mapState({
				StationList: 'Stations',
				EquipmentModelDefine: 'EquipmentModelDefine'
			})
		},
		methods: {
			handleSubmit: function(option) {
				const _this = this;
				// this.getParametersItemList();
				_this.$refs.equipPageList.getList();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220;
			},
			getParametersItemList: function() {
				const _this = this;
				this.$axios.post(webapi.base_api_url + '/Parameters/GetParametersItemList').then(res => {
					if (res.status == 200 && res.data.Code == 0) {
						_this.dateItemDatas = res.data.Data.List;
						_this.dateItemDatas = _this.dateItemDatas.map(obj => {
							console.log(obj);
							return {
								...obj,
								ReadValue: '',
								WriteValue: obj.DefaultValue,
								Result: '',
								ResultMsg: '',
							}
						});
						// console.log("data: ", JSON.stringify(_this.dateItemDatas));
					}
				})
			},
			readParamValue: function(param) {
				const _this = this;
				let selections = _this.$refs.equipSelection.getSelection();
				if (selections.length != 1) {
					this.$Message.warning('必须选择一台桩');
					return;
				}
				for (let ei = 0; ei < _this.equipDatas.length; ei++) {
					let index = selections.findIndex(v => v.EquipmentNo == this.equipDatas[ei].EquipmentNo);
					if (index != -1) _this.equipDatas[ei].Result = '';
				}
				for (let pi = 0; pi < _this.dateItemDatas.length; pi++) {
					if (param.Id == _this.dateItemDatas[pi].Id) {
						_this.dateItemDatas[pi].ReadValue = '';
						_this.dateItemDatas[pi].Result = '';
					}
				}
				param.Equipments = selections.map(obj => {
					return obj.EquipmentNo;
				});
				this.$axios.post(webapi.base_api_url + '/Parameters/ReadParameterValue', param).then(res => {
					if (res.status == 200 && res.data.Code == 0) {
						let results = res.data.Data.List;
						for (let i = 0; i < results.length; i++) {
							for (let ei = 0; ei < _this.equipDatas.length; ei++) {
								if (_this.equipDatas[ei].EquipmentNo == results[i].EquipmentNo) {
									_this.equipDatas[ei].Result = results[i].ErrorCode == 0 ? '1' : '2';
									_this.equipDatas[ei].ResultMsg = results[i].ErrorMessage;
								}
							}
							for (let pi = 0; pi < _this.dateItemDatas.length; pi++) {
								if (_this.dateItemDatas[pi].Id == results[i].Id) {
									_this.dateItemDatas[pi].ReadValue = results[i].DataValue;
									_this.dateItemDatas[pi].Result = results[i].ErrorCode == 0 ? '1' : '2';
									_this.dateItemDatas[pi].ResultMsg = results[i].ErrorMessage;
								}
							}
						}
					}
				})
			},
			writeParamValue: function(param) {
				const _this = this;
				let selections = _this.$refs.equipSelection.getSelection();
				if (selections.length < 1) {
					this.$Message.warning('至少选择一台桩');
					return;
				}
				for (let ei = 0; ei < _this.equipDatas.length; ei++) {
					let index = selections.findIndex(v => v.EquipmentNo == this.equipDatas[ei].EquipmentNo);
					if (index != -1) _this.equipDatas[ei].Result = "";
				}
				for (let pi = 0; pi < _this.dateItemDatas.length; pi++) {
					if (param.Id == _this.dateItemDatas[pi].Id) _this.dateItemDatas[pi].Result = '';
				}
				param.Equipments = selections.map(obj => {
					return obj.EquipmentNo;
				});

				this.$axios.post(webapi.base_api_url + '/Parameters/WriteParameterValue', param).then(res => {
					if (res.status == 200 && res.data.Code == 0) {
						let results = res.data.Data.List;
						for (let i = 0; i < results.length; i++) {
							for (let ei = 0; ei < _this.equipDatas.length; ei++) {
								if (_this.equipDatas[ei].EquipmentNo == results[i].EquipmentNo) {
									_this.equipDatas[ei].Result = results[i].ErrorCode == 0 ? '1' : '2';
									_this.equipDatas[ei].ResultMsg = results[i].ErrorMessage;
								}
							}
							for (let pi = 0; pi < _this.dateItemDatas.length; pi++) {
								if (_this.dateItemDatas[pi].Id == results[i].Id) {
									// _this.dateItemDatas[pi].WriteValue = param.WriteValue;
									_this.dateItemDatas[pi].Result = results[i].ErrorCode == 0 ? '1' : '2';
									_this.dateItemDatas[pi].ResultMsg = results[i].ErrorMessage;
								}
							}
						}
					}
				})
			},
			getDeviceList: function(data) {
				this.equipDatas = data.Data.List.map(obj => {
					return {
						...obj,
						Result: ''
					}
				})
			},
			showReadValue(data) {
				if (data.ReadAble == 0 || data.ReadValue == '') return '';
				if (data.WidgetType == 2) {
					for (let i = 0; i < data.WidgetOptionalDefine.length; i++) {
						if (data.WidgetOptionalDefine[i].Value == data.ReadValue) {
							return data.WidgetOptionalDefine[i].Text;
						}
					}
				} else if (data.WidgetType == 4) {
					if (data.ReadValue == 1) return '启用';
					else return '禁用'
				}
				return data.ReadValue;
			},
			onEquipSelect(selection, row) {
				for (let i = 0; i < this.equipDatas.length; i++) {
					let index = selection.findIndex(v => v.EquipmentNo == this.equipDatas[i].EquipmentNo);
					this.equipDatas[i]._checked = (index != -1);
				}
			}
		}
	}
</script>

<style scoped>
	/* 	ivu-table, .h-table {
		height: calc(100vh - 200px);
	} */

	/deep/.ivu-form-item {
		margin-bottom: 0;
	}

	/deep/.ivu-alert {
		margin-bottom: 0;
		padding: 8px 16px;
	}

	/* 	/deep/.ivu-table-cell {
		height: 100%;
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		justify-items: center;
	} */
	.cell-div {
		height: 100% !important;
		width: 100% !important;
		display: flex;
		flex-direction: column;
		justify-content: center;
		justify-items: center;
	}
</style>